// extracted by mini-css-extract-plugin
export default {"shareModal":"ShareButtonModal_shareModal__MCUGP","copyField":"ShareButtonModal_copyField__3mVE0","iconWrapper":"ShareButtonModal_iconWrapper__ll0YX"};